import Join from "../component/join/join"
import Login from "../component/login/login"
import Cards from "../component/cards/card"
function Joinn(){
    return(
        <>
        <Join/>
        <Cards/>
        <Login/>
        </>
    )
}
export default Joinn